import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const SearchBar = ({
  showType,
  value,
  onChange,
  filter,
  handleFilter,
  handleSubmit
}) => {
  const [errorMessage, setErrorMessage] = useState("");

  const handleFormSubmit = (e) => {
    e.preventDefault();

    // Check if both the query and the filter are filled
    // if (!value && !filter) {
    //   setErrorMessage("Veuillez sélectionner un type de riad et saisir le nom du riad.");
    // } 
    // if(!value){
    // setErrorMessage("Veuillez saisir le nom de riad.");
   
    // }
     if(!filter){
    setErrorMessage("Veuillez sélectionner un type de riad.");
   
    }
    else {
      setErrorMessage(""); // Clear error message if valid
      handleSubmit(e); // Call the original handleSubmit function if everything is valid
    }
  };

  return (
    <div className="blog-sidebar d-flex justify-content-center">
      <div className="widget search-widget col-12 col-md-6 col-sm-10"  > 
        <form
          onSubmit={handleFormSubmit}
          className="p-3 bg-white bg-opacity-25 rounded shadow-sm"
        >
          <div className="input-group">
            <div className="w-100">
              <input
                type="text"
                className="form-control"
                placeholder="Rechercher un riad..."
                value={value}
                onChange={onChange}
              />
              <button type="submit">
                <i className="ti-search"></i>
              </button>
            </div>
          </div>
          {showType && (
            <div className="mt-3">
              <select
                className="form-select"
                id="riadFilter"
                value={filter}
                onChange={(e) => handleFilter(e)} // Fix here
              >
                <option value="">Type de Riad</option>
                <option value="renove">Riad rénové</option>
                <option value="a renover">Riad à rénover</option>
              </select>
            </div>
          )}

          {errorMessage && (
            <div className="mt-3 text-warning">
              <strong>{errorMessage}</strong>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default SearchBar;
